:host{font-weight:400;font-size:16px;font-family:GothamNarrowBook,sans-serif}
/*# sourceMappingURL=question-yesno-buttons.component-MRDKJBP7.css.map */
